import { Amplify } from 'aws-amplify';

import { authEnv } from '@/utils/config/auth';

let configured = false;

/** Call once on app load. */
export function configureAmplify(): void {
  if (configured) {
    return;
  }

  const { region, userPoolId, userPoolWebClientId, cookieStorageDomain } = authEnv;

  if (!region || !userPoolId || !userPoolWebClientId) {
    console.error(
      '[Auth] Cognito is not configured: set REACT_APP_AUTH_REGION, REACT_APP_AUTH_USER_POOL_ID, REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID',
    );
    return;
  }

  const authConfig: Record<string, unknown> = {
    region,
    userPoolId,
    userPoolWebClientId,
    authenticationFlowType: 'USER_SRP_AUTH',
  };

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    if (cookieStorageDomain && !isLocal) {
      authConfig.cookieStorage = {
        domain: cookieStorageDomain,
        path: '/',
        expires: 365,
        secure: true,
        sameSite: 'none',
      };
    }
  }

  Amplify.configure({ Auth: authConfig });
  configured = true;
}
